<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('evaluation')"
                        :isNewButton="checkPermission('evaluation_store')"
                        @new-button-click="createFormShow"
                        @filter-div-status="datatable.filterStatus = $event">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('evaluation')"
                              :isNewButton="checkPermission('evaluation_store')"
                              @new-button-click="createFormShow"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>
            <datatable-filter
                v-show="datatable.filterStatus"
                @filter="filter"
                @filterClear="filterClear"
                :exportExcel="checkPermission('evaluation_excelexport')"
                @exportExcel="exportExcel"
            >
                <b-row>
                    <b-col sm="6">
                        <b-form-group :label="$t('name')">
                            <b-form-input v-model="datatable.queryParams.filter.name">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group :label="$t('status')">
                          <status-selectbox
                              v-model="datatable.queryParams.filter.status"
                          />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group :label="$t('passing_grade')">
                            <b-form-input type="number" v-model="datatable.queryParams.filter.passing_grade">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable
                :isLoading.sync="datatable.isLoading"
                :columns="datatable.columns"
                :rows="datatable.rows"
                :total="datatable.total"
                :queryParams="datatable.queryParams"
                :lineNumbers="false"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange"
                v-show="datatable.showTable"
            >
            </datatable>

            <CommonModal ref="showModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()" v-if="checkPermission('evaluation_show')">
                <template v-slot:CommonModalTitle>
                    {{ $t('show').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <show-form :formId="formId"
                               v-if="formProcess=='show'"
                    />
                </template>
            </CommonModal>

            <CommonModal ref="createFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('evaluation_store')">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toUpperCase() }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 v-if="formProcess=='create'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="updateFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('evaluation_update')">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toUpperCase() }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess=='update'"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from "@/layouts/AppLayout";
    import Header from "@/layouts/AppLayout/Header"
    import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
    //Component
    import DatatableFilter from "@/components/datatable/DatatableFilter";
    import Datatable from "@/components/datatable/Datatable";
    import CommonModal from "@/components/elements/CommonModal";
    //Other
    import qs from "qs";
    //Service
    import EvaluationService from "@/services/EvaluationService";
    //Page
    import CreateForm from "./CreateForm"
    import UpdateForm from "./UpdateForm"
    import ShowForm from "./ShowForm"
    import evaluationService from "../../../services/EvaluationService";

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,

            CreateForm,
            UpdateForm,
            ShowForm
        },
        metaInfo() {
            return {
                title: this.$t("evaluation"),
            };
        },
        data() {
            return {
                selectCode: null,
                formId: 0,
                form: {},
                formProcess: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: "",
                            field: "buttons",
                            html: true,
                            sortable: false,
                            tdClass: "p-0 text-center w-40 align-middle",
                            buttons: [
                                {
                                    text: this.$t('show'),
                                    class: 'ri-search-eye-line',
                                    permission: 'evaluation_show',
                                    callback: (row) => {
                                        this.showForm(row.id);
                                    }
                                },
                                {
                                    text: this.$t("edit"),
                                    class: "ri-edit-box-line",
                                    permission: 'evaluation_update',
                                    callback: (row) => {
                                        this.loadData(row.id);
                                    },
                                },
                                {
                                    text: this.$t("delete"),
                                    class: "ri-delete-bin-2-line",
                                    permission: 'evaluation_delete',
                                    callback: (row) => {
                                        this.delete(row.id);
                                    },
                                },
                                {
                                    text: this.$t("evaluation_assessments"),
                                    class: "ri-list-check ",
                                    permission: 'evaluationassessment_show',
                                    callback: (row) => {
                                        this.formId = row.id;
                                        this.openEvaluationAssessment(row);
                                    },
                                },
                            ],
                        },
                        {
                            label: this.$t("id"),
                            field: "id",
                            sortable: true,
                        },
                        {
                            label: this.$t("name"),
                            field: "name",
                            sortable: true,
                        },
                        {
                          label: this.$t("status"),
                          field: "status",
                          sortable: true,
                          formatFn: this.getStatusText
                        },
                        {
                          label: this.$t("passing_grade"),
                          field: "passing_grade",
                          sortable: true,
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: "id",
                        page: 1,
                        limit: 20,
                    },
                },
            };
        },
        methods: {
            openEvaluationAssessment({name}) {
                if (this.formId > 0) {
                    this.$router.push({
                        path: "/evaluation/assessments/" + this.formId,
                        query: { name: name }
                    });
                }
            },
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == "desc" ? "-" : "";
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams,
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                };

                return EvaluationService.getAll(config)
                                       .then((response) => {
                                           this.datatable.rows = response.data.data;
                                           this.datatable.total = response.data.pagination.total;
                                       })
                                       .finally(() => {
                                           this.datatable.isLoading = false;
                                       });
            },
            loadData(id) {
                this.formProcess = "update";
                this.formId = id;
                EvaluationService.get(id)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.$refs.updateFormModal.$refs.commonModal.show();
                                })
                                .catch((error) => {
                                    if (error.data.message) {
                                        this.$toast.error(this.$t("api." + error.data.message));
                                    }
                                });
            },
            delete(id) {
                this.$swal
                  .fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                  })
                  .then((result) => {
                    if (result.isConfirmed) {
                      EvaluationService.del(id)
                          .then(response => {
                            this.$toast.success(this.$t('api.' + response.data.message))
                            this.getRows()
                          })
                          .catch(error => {
                            this.$toast.error(this.$t('api.' + error.data.message))
                          })
                    }
                  })
            },
            async createFormSuccess() {
                this.$refs.createFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            async updateFormSuccess() {
                this.$refs.updateFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            createFormShow() {
                this.formId = null
                this.form = {};
                this.formProcess = 'create'
                this.$refs.createFormModal.$refs.commonModal.show()
            },
            formClear() {
                this.formId = null
                this.formProcess = null
            },
            showForm(id) {
                this.formId = id
                this.formProcess = 'show'
                this.$refs.showModal.$refs.commonModal.show()
            },
            exportExcel(){
                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return evaluationService.exportExcel(config)
                    .then((response) => {
                        this._downloadFile(response,this.$t('evaluation')+'.xlsx')
                    })
                    .catch(err=>this.showErrors(err))
            }
        },
    };
</script>

